import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {type UnitOnRent, unitOnRentSchema} from './schemas'

/** List units of a rental asset type that are on rent on other orders during the job. */
export async function listUnitsOnRent(
    jobId: string,
    rentalAssetTypeId: string,
): Promise<UnitOnRent[]> {
    const params = new URLSearchParams({rental_asset_type_id: rentalAssetTypeId})
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/units-on-rent?${params.toString()}`)
    return z.array(unitOnRentSchema).parse(raw)
}
